import { StoreState } from 'state/rootReducer';
import { TextTemplateState } from './types';

export const getIsTemplateModalOpen = (state: StoreState): boolean =>
  state.records.template.isModalSaveTemplateOpen;

export const getTemplate = (state: StoreState): TextTemplateState => ({
  ...state.records.template,
});
